<template>
  <div id="tabPayoutAccounts" class="page invoice-wrap">
    <section class="flex md12 xs12">
      <div class="flex md12 xs12 text-right">
        <el-button type="success" class="account-statement" @click="queryPayoutAccounts">{{ $t('basic.button.refresh') }}</el-button>
      </div>
      <div class="dataGrid-report">
        <el-table :data="payoutAccountBalanceNotZero" tooltip-effect="light" class="dataGrid-report-table">
          <el-table-column prop="account_id" :label="$t('tables.listing.transfer_account_id')"></el-table-column>
          <el-table-column prop="account_name" :label="$t('finance.accountName')"></el-table-column>
          <el-table-column prop="currency" :label="$t('t.currency')"></el-table-column>
          <el-table-column prop="balance" :label="$t('t.balance')">
            <template slot-scope="scope">
              {{ Number(scope.row.balance).toFixed(2) }}
            </template>
          </el-table-column>
        </el-table>
      </div>
    </section>
  </div>
</template>

<script>
var moment = require("moment-timezone");

export default {
  name: 'PayoutAccounts',
  data() {
    return {
      noData: this.$t("t.noDataNoOrder"),
    }
  },
  methods: {
		queryPayoutAccounts() {
      this.$emit('update')
		},
    loadingFullScreen(controller, txt, className) {
			this[controller] = this.$loading({
				lock: true,
				text: txt,
				spinner: className,
				background: 'rgba(0, 0, 0, 0.7)',
			})
		}
  },
  components: {},
  computed: {
    payoutAccountBalanceNotZero() {
      return this.payoutAccountsList.filter(account => Number(account.balance))
    }
  },
  props: {
    payoutAccountsList: {
      type: Array,
      default: () => []
    }
  }
}
</script>
<style lang="scss" scoped>
@import "./payoutAccounts.scss";
*,
*:after,
*:before {
	box-sizing: border-box;
	margin: 0;
	padding: 0;
}

.handle-view {
  padding: 9px 15px;
}
.handle-close {
  padding: 0.5rem 2rem;
}
/deep/ .show-detail {
  .modal-lg {
    max-width: 950px;
  }
}
</style>
